import {
    faAngleRight,
    faEdit,
    faEnvelope,
    faEye,
    faPlus,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ColumnDescription } from "react-bootstrap-table-next";
import Swal from "sweetalert2";
import SpinnerComponent from "../../../Components/Loding/Spinner";
import ModalComponent from "../../../Components/Modais";
import Table from "../../../Components/Table";
import CadastrarEEditarAudiencia from "./CadastrarEEditarAudiencia";
import {
    DeletarAudienciaController,
    EditarAudienciaController,
} from "../../../Controllers/Automacao/Audiencia/AudienciaControllers";
import { IAudiencia } from "../../../Interfaces/Automacao/Audiencia/AudienciaInterfaces";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import ComunicadoEmMassa from "./ComunicadoEmMassa";
import { useGestaoAudiencia } from "./useGestaoAudiencia";
import { AbrirAtendimento } from "../../../Components/CardsPages/Atendimento/AbrirAtendimento";
import { ACESSOS } from "../../../Routes/Acessos";

export default function GestaoAudiencia() {
    const {
        updateList,
        location,
        show,
        setShow,
        modal,
        setModal,
        lstAudiencia,
    } = useGestaoAudiencia();

    function RowTable(cell: any, row: IAudiencia) {
        return (
            <>
                <div className="rowCapys">
                    <div>
                        <h4>{row.DS_AUDIENCIA}</h4>
                    </div>
                    <div className="col-tools">
                        <div className="toolsTable">
                            <label className="text-white">
                                {row.FL_ATIVO ? "Desativar" : "Ativar"}
                            </label>
                            <div className="tools-capys">
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="tooltip-disabled">
                                            {row.FL_ATIVO
                                                ? "Desativar Audiência"
                                                : "Ativar Audiência"}
                                        </Tooltip>
                                    }
                                >
                                    <span
                                        className="switch switch-outline switch-sm switch-icon switch-success"
                                        data-toggle="tooltip"
                                    >
                                        <label>
                                            <input
                                                id="FL_ATIVO"
                                                name="FL_ATIVO"
                                                checked={row.FL_ATIVO}
                                                type="checkbox"
                                                onChange={() => {
                                                    EditarAudienciaController({
                                                        ...row,
                                                        FL_ATIVO: !row.FL_ATIVO,
                                                    }).then(updateList);
                                                }}
                                            />
                                            <span></span>
                                        </label>
                                    </span>
                                </OverlayTrigger>
                            </div>
                        </div>
                        <div className="Button-Tools">
                            <button
                                className="btn btn-light-primary font-weight-bold mr-2"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        size: "xl",
                                        headerComponent: "Abrir Atendimento",
                                        IconHeader: faAngleRight,
                                        Component: () => (
                                            <AbrirAtendimento
                                                ID_MODULO={
                                                    ACESSOS.ATENDIMENTO
                                                        .ID_MODULO
                                                }
                                                setShow={setShow}
                                                ID_AUDIENCIA={row.ID_AUDIENCIA}
                                            />
                                        ),
                                    });
                                }}
                            >
                                Abrir Atendimento
                            </button>
                            <Link
                                to={`/${location.pathname.split("/")[1]}/${
                                    row.ID_AUDIENCIA
                                }/Contatos`}
                                className="btn btn-outline-success mr-2 "
                            >
                                <FontAwesomeIcon
                                    icon={faEye}
                                    className="mr-2"
                                />
                                Visualizar
                            </Link>
                            <button
                                className="btn btn-outline-primary font-weight-bold mr-2"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        Component: () =>
                                            CadastrarEEditarAudiencia({
                                                setShow,
                                                updateList,
                                                audienciaValues: row,
                                            }),
                                        noFooter: true,
                                        noHeader: true,
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faEdit} size="lg" />
                                Editar
                            </button>
                            <button
                                className="btn btn-outline-danger font-weight-bold mr-2"
                                onClick={() => {
                                    Swal.fire({
                                        title: "Deseja apagar esta Audiência?",
                                        icon: "info",
                                        buttonsStyling: false,
                                        confirmButtonText:
                                            "<i class='la la-check'></i> Sim!",
                                        showCancelButton: true,
                                        cancelButtonText:
                                            "<i class='la la-thumbs-down'></i> Não",
                                        customClass: {
                                            confirmButton:
                                                "btn btn-outline-success",
                                            cancelButton: "btn btn-default",
                                        },
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            DeletarAudienciaController(
                                                row.ID_AUDIENCIA
                                            ).then(() => {
                                                updateList();
                                            });
                                        }
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faTrash} size="lg" />{" "}
                                Excluir
                            </button>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    const ColunsAudiencia: Array<ColumnDescription> = [
        {
            dataField: "DS_AUDIENCIA",
            text: "Audiencia",
            formatter: RowTable,
            sort: true,
            isDummyField: true,
        },
    ];

    return lstAudiencia !== undefined ? (
        <>
            <div className="card card-custom" id="kt_page_sticky_card">
                <div className="card-header border-0 pt-5">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label font-weight-bolder text-dark">
                            Gestão de Audiência
                        </span>
                    </h3>
                    <div className="card-toolbar">
                        <button
                            className="btn btn-success font-weight-bold mr-2"
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    Component: () =>
                                        CadastrarEEditarAudiencia({
                                            setShow,
                                            updateList,
                                        }),
                                    noFooter: true,
                                    noHeader: true,
                                });
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faPlus}
                                size="lg"
                                className="mr-2"
                            />
                            Nova Audiência
                        </button>
                        <button
                            className="btn btn-info font-weight-bold "
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    Component: () => (
                                        <ComunicadoEmMassa
                                            setModal={setShow}
                                            updateList={updateList}
                                        />
                                    ),
                                    noFooter: true,
                                    size: "lg",
                                    noHeader: true,
                                });
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faEnvelope}
                                size="lg"
                                className="mr-2"
                            />
                            Comunicado Em Massa
                        </button>
                    </div>
                </div>
                <div className="card-body pt-2 pb-0 mt-n3">
                    <div className="table-responsive-sm">
                        <Table
                            keyField="ID_AUDIENCIA"
                            data={lstAudiencia}
                            columns={ColunsAudiencia}
                        />
                    </div>
                </div>
                <ModalComponent
                    show={show}
                    setShow={setShow}
                    ModalComponent={modal}
                />
            </div>
        </>
    ) : (
        <SpinnerComponent />
    );
}
